import { useEffect } from 'react';
import { AppUuidConfig } from '../../types';
import { getStepsFromAppUuidConfig } from '../../utils/getStepsFromAppUuidConfig/getStepsFromAppUuidConfig.utils';
import { useAppDispatch } from '~/hooks/useAppDispatch';
import { addSteps } from '~/store/slices/updateApplication/updateApplication.slice';
import { generateDefaultStepsFromConfig } from '../utils/generateDefaultStepsFromConfig.utils';
import { useUpdateApplicationSelectors } from '~/store/selectors/updateApplication/updateApplication.selector';

const useAddUpdateApplicationSteps = (appUuidConfig: AppUuidConfig | null) => {
  const dispatch = useAppDispatch();

  const { currentStepIndex, allSteps } = useUpdateApplicationSelectors();

  useEffect(() => {
    if (!appUuidConfig) return;

    const stepsFromConfig = getStepsFromAppUuidConfig(appUuidConfig);
    const stepObjects = generateDefaultStepsFromConfig(stepsFromConfig);

    dispatch(addSteps(stepObjects));
  }, [appUuidConfig]);

  return {
    currentStepIndex,
    allSteps,
  };
};

export default useAddUpdateApplicationSteps;
